import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ReportFilterReport011Service {

  constructor() {
  }

  static generate(filters: any, afilters: any[]) {
    if (filters.code !== undefined) //
      afilters.push({
        field: 'chamado',
        value: filters.code,
        matchMode: 'startsWith'
      });

    if (filters.category !== undefined) //
      afilters.push({
        field: 'categoria',
        value: filters.category,
        matchMode: 'startsWith'
      });

    if (filters.status !== undefined) //
      afilters.push({
        field: 'situacao',
        value: filters.status,
        matchMode: 'startsWith'
      });

    if (filters.enrollment !== undefined) //
      afilters.push({
        field: 'matricula',
        value: filters.enrollment,
        matchMode: 'startsWith'
      });

    if (filters.name !== undefined) //
      afilters.push({
        field: 'nome',
        value: filters.name,
        matchMode: 'startsWith'
      });

    if (filters.state !== undefined) //
      afilters.push({
        field: 'uf',
        value: filters.state,
        matchMode: 'startsWith'
      });

    if (filters.role !== undefined) //
      afilters.push({
        field: 'perfil',
        value: filters.role,
        matchMode: 'startsWith'
      });
  }

}
